module.exports = __webpack_public_path__ + "img/thumb_2018-03.41dbcf93.jpg";